module.exports = __webpack_public_path__ + "img/report-sample-08@3x.7c463549.png";